import React from 'react';
import { companyInfo, images } from '../data/mock';
import { Button } from './ui/button';
import { ArrowRight, Zap, CheckCircle2 } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 to-teal-50 relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-0 right-0 w-1/2 h-full">
        <img
          src={images.classroom}
          alt="Classroom"
          className="w-full h-full object-cover opacity-10"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-teal-100 rounded-full px-4 py-2 mb-8">
            <Zap className="w-4 h-4 text-teal-600" />
            <span className="text-teal-700 text-sm font-medium">
              Start Your Digital Journey Today
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-6 leading-tight">
            Ready to Modernize Your School Management?
          </h2>
          <p className="text-lg text-slate-600 mb-10 leading-relaxed">
            Join 100+ schools across India who have transformed their operations with EdKonect. Experience the power of Integrated Campus Management.
          </p>

          {/* Benefits */}
          <div className="flex flex-wrap justify-center gap-6 mb-10">
            {[
              'Free Demo',
              'Easy Setup',
              'Dedicated Support',
              'No Hidden Costs'
            ].map((benefit, index) => (
              <div key={index} className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-teal-500" />
                <span className="text-slate-700 font-medium">{benefit}</span>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <a
            href={companyInfo.appUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              size="lg"
              className="rounded-full bg-teal-500 hover:bg-teal-600 text-white px-10 py-6 text-lg font-semibold shadow-xl shadow-teal-500/25 transition-all hover:shadow-2xl hover:shadow-teal-500/30 hover:-translate-y-0.5"
            >
              Get Started Now
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
